/**
 * document-routes
 * com.ksoft
 *
 * OpenAPI spec version: 1.1
 * Contact: fposada@ksoftonline.co
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { BasePostulacion } from '../model/basePostulacion';
import { Candidato } from '../model/candidato';
import { CandidatoVO } from '../model/candidatoVO';
import { InfoEconomica } from '../model/infoEconomica';
import { InfoSolicitud } from '../model/infoSolicitud';
import { InformacionEconomica } from '../model/informacionEconomica';
import { InformacionEconomicaVO } from '../model/informacionEconomicaVO';
import { LicenciaConduccion } from '../model/licenciaConduccion';
import { LicenciaConduccionVO } from '../model/licenciaConduccionVO';
import { ResumenVisita } from '../model/resumenVisita';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class InfoPersonaService {

    protected basePath = 'http://localhost:8083/dr';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param pid 
     * @param rid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getInfoAcademica(pid: any, rid: any, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public getInfoAcademica(pid: any, rid: any, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public getInfoAcademica(pid: any, rid: any, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public getInfoAcademica(pid: any, rid: any, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (pid === null || pid === undefined) {
            throw new Error('Required parameter pid was null or undefined when calling getInfoAcademica.');
        }

        if (rid === null || rid === undefined) {
            throw new Error('Required parameter rid was null or undefined when calling getInfoAcademica.');
        }

        let headers = this.defaultHeaders;
        if (pid !== undefined && pid !== null) {
            headers = headers.set('pid', String(pid));
        }
        if (rid !== undefined && rid !== null) {
            headers = headers.set('rid', String(rid));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/i-p/academica`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param pid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getInfoEconomica(pid: any, observe?: 'body', reportProgress?: boolean): Observable<InfoEconomica>;
    public getInfoEconomica(pid: any, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<InfoEconomica>>;
    public getInfoEconomica(pid: any, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<InfoEconomica>>;
    public getInfoEconomica(pid: any, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (pid === null || pid === undefined) {
            throw new Error('Required parameter pid was null or undefined when calling getInfoEconomica.');
        }

        let headers = this.defaultHeaders;
        if (pid !== undefined && pid !== null) {
            headers = headers.set('pid', String(pid));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<InfoEconomica>('get',`${this.basePath}/i-p/economica`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param pid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getInfoFamiliares(pid: any, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public getInfoFamiliares(pid: any, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public getInfoFamiliares(pid: any, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public getInfoFamiliares(pid: any, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (pid === null || pid === undefined) {
            throw new Error('Required parameter pid was null or undefined when calling getInfoFamiliares.');
        }

        let headers = this.defaultHeaders;
        if (pid !== undefined && pid !== null) {
            headers = headers.set('pid', String(pid));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/i-p/familiares`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param pid 
     * @param rid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getInfoLaboral(pid: any, rid: any, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public getInfoLaboral(pid: any, rid: any, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public getInfoLaboral(pid: any, rid: any, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public getInfoLaboral(pid: any, rid: any, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (pid === null || pid === undefined) {
            throw new Error('Required parameter pid was null or undefined when calling getInfoLaboral.');
        }

        if (rid === null || rid === undefined) {
            throw new Error('Required parameter rid was null or undefined when calling getInfoLaboral.');
        }

        let headers = this.defaultHeaders;
        if (pid !== undefined && pid !== null) {
            headers = headers.set('pid', String(pid));
        }
        if (rid !== undefined && rid !== null) {
            headers = headers.set('rid', String(rid));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/i-p/laboral`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param pid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getInfoLicencia(pid: any, observe?: 'body', reportProgress?: boolean): Observable<LicenciaConduccion>;
    public getInfoLicencia(pid: any, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<LicenciaConduccion>>;
    public getInfoLicencia(pid: any, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<LicenciaConduccion>>;
    public getInfoLicencia(pid: any, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (pid === null || pid === undefined) {
            throw new Error('Required parameter pid was null or undefined when calling getInfoLicencia.');
        }

        let headers = this.defaultHeaders;
        if (pid !== undefined && pid !== null) {
            headers = headers.set('pid', String(pid));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<LicenciaConduccion>('get',`${this.basePath}/i-p/licencia`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param pid 
     * @param rid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getInfoMedica(pid: any, rid: any, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public getInfoMedica(pid: any, rid: any, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public getInfoMedica(pid: any, rid: any, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public getInfoMedica(pid: any, rid: any, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (pid === null || pid === undefined) {
            throw new Error('Required parameter pid was null or undefined when calling getInfoMedica.');
        }

        if (rid === null || rid === undefined) {
            throw new Error('Required parameter rid was null or undefined when calling getInfoMedica.');
        }

        let headers = this.defaultHeaders;
        if (pid !== undefined && pid !== null) {
            headers = headers.set('pid', String(pid));
        }
        if (rid !== undefined && rid !== null) {
            headers = headers.set('rid', String(rid));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/i-p/medica`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param doc 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getInfoPersona(doc: any, observe?: 'body', reportProgress?: boolean): Observable<Candidato>;
    public getInfoPersona(doc: any, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Candidato>>;
    public getInfoPersona(doc: any, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Candidato>>;
    public getInfoPersona(doc: any, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (doc === null || doc === undefined) {
            throw new Error('Required parameter doc was null or undefined when calling getInfoPersona.');
        }

        let headers = this.defaultHeaders;
        if (doc !== undefined && doc !== null) {
            headers = headers.set('doc', String(doc));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Candidato>('get',`${this.basePath}/i-p/persona`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param rid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getInfoPostulacion(rid: any, observe?: 'body', reportProgress?: boolean): Observable<BasePostulacion>;
    public getInfoPostulacion(rid: any, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BasePostulacion>>;
    public getInfoPostulacion(rid: any, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BasePostulacion>>;
    public getInfoPostulacion(rid: any, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (rid === null || rid === undefined) {
            throw new Error('Required parameter rid was null or undefined when calling getInfoPostulacion.');
        }

        let headers = this.defaultHeaders;
        if (rid !== undefined && rid !== null) {
            headers = headers.set('rid', String(rid));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<BasePostulacion>('get',`${this.basePath}/i-p/postulacion`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param pid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getInfoReferencias(pid: any, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public getInfoReferencias(pid: any, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public getInfoReferencias(pid: any, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public getInfoReferencias(pid: any, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (pid === null || pid === undefined) {
            throw new Error('Required parameter pid was null or undefined when calling getInfoReferencias.');
        }

        let headers = this.defaultHeaders;
        if (pid !== undefined && pid !== null) {
            headers = headers.set('pid', String(pid));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/i-p/referencias`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param rid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getInfoSolicitud(rid: any, observe?: 'body', reportProgress?: boolean): Observable<InfoSolicitud>;
    public getInfoSolicitud(rid: any, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<InfoSolicitud>>;
    public getInfoSolicitud(rid: any, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<InfoSolicitud>>;
    public getInfoSolicitud(rid: any, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (rid === null || rid === undefined) {
            throw new Error('Required parameter rid was null or undefined when calling getInfoSolicitud.');
        }

        let headers = this.defaultHeaders;
        if (rid !== undefined && rid !== null) {
            headers = headers.set('rid', String(rid));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<InfoSolicitud>('get',`${this.basePath}/i-p/solicitud`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param pid 
     * @param rid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getResumen(pid: any, rid: any, observe?: 'body', reportProgress?: boolean): Observable<ResumenVisita>;
    public getResumen(pid: any, rid: any, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResumenVisita>>;
    public getResumen(pid: any, rid: any, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResumenVisita>>;
    public getResumen(pid: any, rid: any, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (pid === null || pid === undefined) {
            throw new Error('Required parameter pid was null or undefined when calling getResumen.');
        }

        if (rid === null || rid === undefined) {
            throw new Error('Required parameter rid was null or undefined when calling getResumen.');
        }

        let headers = this.defaultHeaders;
        if (pid !== undefined && pid !== null) {
            headers = headers.set('pid', String(pid));
        }
        if (rid !== undefined && rid !== null) {
            headers = headers.set('rid', String(rid));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ResumenVisita>('get',`${this.basePath}/i-p/resumen`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTiposDocumentosActivos(observe?: 'body', reportProgress?: boolean): Observable<any>;
    public getTiposDocumentosActivos(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public getTiposDocumentosActivos(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public getTiposDocumentosActivos(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/i-p/tipos-documentos`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public pingIP1(observe?: 'body', reportProgress?: boolean): Observable<any>;
    public pingIP1(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public pingIP1(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public pingIP1(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/i-p/ping`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param pid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateInfoAcademica(body: any, pid: any, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public updateInfoAcademica(body: any, pid: any, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public updateInfoAcademica(body: any, pid: any, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public updateInfoAcademica(body: any, pid: any, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateInfoAcademica.');
        }

        if (pid === null || pid === undefined) {
            throw new Error('Required parameter pid was null or undefined when calling updateInfoAcademica.');
        }

        let headers = this.defaultHeaders;
        if (pid !== undefined && pid !== null) {
            headers = headers.set('pid', String(pid));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/i-p/academica`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param pid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateInfoEconomica(body: InformacionEconomicaVO, pid: any, observe?: 'body', reportProgress?: boolean): Observable<InformacionEconomica>;
    public updateInfoEconomica(body: InformacionEconomicaVO, pid: any, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<InformacionEconomica>>;
    public updateInfoEconomica(body: InformacionEconomicaVO, pid: any, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<InformacionEconomica>>;
    public updateInfoEconomica(body: InformacionEconomicaVO, pid: any, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateInfoEconomica.');
        }

        if (pid === null || pid === undefined) {
            throw new Error('Required parameter pid was null or undefined when calling updateInfoEconomica.');
        }

        let headers = this.defaultHeaders;
        if (pid !== undefined && pid !== null) {
            headers = headers.set('pid', String(pid));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<InformacionEconomica>('put',`${this.basePath}/i-p/economica`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param pid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateInfoFamiliares(body: any, pid: any, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public updateInfoFamiliares(body: any, pid: any, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public updateInfoFamiliares(body: any, pid: any, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public updateInfoFamiliares(body: any, pid: any, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateInfoFamiliares.');
        }

        if (pid === null || pid === undefined) {
            throw new Error('Required parameter pid was null or undefined when calling updateInfoFamiliares.');
        }

        let headers = this.defaultHeaders;
        if (pid !== undefined && pid !== null) {
            headers = headers.set('pid', String(pid));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/i-p/familiares`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param pid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateInfoLaboral(body: any, pid: any, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public updateInfoLaboral(body: any, pid: any, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public updateInfoLaboral(body: any, pid: any, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public updateInfoLaboral(body: any, pid: any, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateInfoLaboral.');
        }

        if (pid === null || pid === undefined) {
            throw new Error('Required parameter pid was null or undefined when calling updateInfoLaboral.');
        }

        let headers = this.defaultHeaders;
        if (pid !== undefined && pid !== null) {
            headers = headers.set('pid', String(pid));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/i-p/laboral`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param pid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateInfoLicencia(body: LicenciaConduccionVO, pid: any, observe?: 'body', reportProgress?: boolean): Observable<LicenciaConduccion>;
    public updateInfoLicencia(body: LicenciaConduccionVO, pid: any, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<LicenciaConduccion>>;
    public updateInfoLicencia(body: LicenciaConduccionVO, pid: any, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<LicenciaConduccion>>;
    public updateInfoLicencia(body: LicenciaConduccionVO, pid: any, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateInfoLicencia.');
        }

        if (pid === null || pid === undefined) {
            throw new Error('Required parameter pid was null or undefined when calling updateInfoLicencia.');
        }

        let headers = this.defaultHeaders;
        if (pid !== undefined && pid !== null) {
            headers = headers.set('pid', String(pid));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<LicenciaConduccion>('put',`${this.basePath}/i-p/licencia`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param pid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateInfoMedica(body: any, pid: any, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public updateInfoMedica(body: any, pid: any, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public updateInfoMedica(body: any, pid: any, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public updateInfoMedica(body: any, pid: any, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateInfoMedica.');
        }

        if (pid === null || pid === undefined) {
            throw new Error('Required parameter pid was null or undefined when calling updateInfoMedica.');
        }

        let headers = this.defaultHeaders;
        if (pid !== undefined && pid !== null) {
            headers = headers.set('pid', String(pid));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/i-p/medica`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param pid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateInfoPersona(body: CandidatoVO, pid: any, observe?: 'body', reportProgress?: boolean): Observable<Candidato>;
    public updateInfoPersona(body: CandidatoVO, pid: any, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Candidato>>;
    public updateInfoPersona(body: CandidatoVO, pid: any, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Candidato>>;
    public updateInfoPersona(body: CandidatoVO, pid: any, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateInfoPersona.');
        }

        if (pid === null || pid === undefined) {
            throw new Error('Required parameter pid was null or undefined when calling updateInfoPersona.');
        }

        let headers = this.defaultHeaders;
        if (pid !== undefined && pid !== null) {
            headers = headers.set('pid', String(pid));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Candidato>('put',`${this.basePath}/i-p/persona`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param pid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateInfoReferencias(body: any, pid: any, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public updateInfoReferencias(body: any, pid: any, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public updateInfoReferencias(body: any, pid: any, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public updateInfoReferencias(body: any, pid: any, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateInfoReferencias.');
        }

        if (pid === null || pid === undefined) {
            throw new Error('Required parameter pid was null or undefined when calling updateInfoReferencias.');
        }

        let headers = this.defaultHeaders;
        if (pid !== undefined && pid !== null) {
            headers = headers.set('pid', String(pid));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('put',`${this.basePath}/i-p/referencias`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
